import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import ReactECharts from "echarts-for-react";
import { MyContextProvider } from "../../App";
import { API_URL,getAuthHeaders,getUserClaimsForUi } from '../../Constant';
import { toast } from 'react-toastify';
import messages from '../../assets/Messages.json';

function MonthlyGrowthRateChart({ fullWidth = false, className }) {

    const token = useContext(MyContextProvider).token;
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [chartYear, setChartYear] = useState('2026');
    const [chartYearOptions, setChartYearOptions] = useState([]);
    const [iipMonth, setIipMonth] = useState(() => {
      const now = new Date();
      return ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][now.getMonth()];
    });
    const config = getAuthHeaders();
    const MONTHS = [
        { code: 'JAN', label: 'January' },
        { code: 'FEB', label: 'February' },
        { code: 'MAR', label: 'March' },
        { code: 'APR', label: 'April' },
        { code: 'MAY', label: 'May' },
        { code: 'JUN', label: 'June' },
        { code: 'JUL', label: 'July' },
        { code: 'AUG', label: 'August' },
        { code: 'SEP', label: 'September' },
        { code: 'OCT', label: 'October' },
        { code: 'NOV', label: 'November' },
        { code: 'DEC', label: 'December' },
      ];
    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const options = [];
        for (let y = 2019; y <= currentYear; y++) {
          options.push(`${y}`);
        }
        setChartYearOptions(options.reverse());
        setChartYear(options[0] || '2019');
      }, []);

    // const option = {
    //     tooltip: {
    //       trigger: "axis",
    //     },
    //     legend: {
    //       bottom: 0,
    //     },
    //     xAxis: {
    //       type: "category",
    //       data: [
    //         "Jan-26",
    //         "Feb-26",
    //         "Mar-26",
    //         "Apr-26",
    //         "May-26",
    //         "Jun-26",
    //         "Jul-26",
    //         "Aug-26",
    //         "Sep-26",
    //         "Oct-26",
    //         "Nov-26",
    //         "Dec-26",
    //       ],
    //     },
    //     yAxis: {
    //       type: "value",
    //       name: "Growth Rate (%)",
    //     },
    //     // dataZoom: [
    //     //   {
    //     //     type: "slider",
    //     //     bottom: 30,
    //     //   },
    //     // ],
    //     series: [
    //       {
    //         name: "Mining",
    //         type: "line",
    //         data: [
    //           -99.8,
    //           0,
    //           0,
    //           55.34,
    //           487.19,
    //           67.59,
    //           221.85,
    //           430.29,
    //           93.12,
    //           153.91,
    //           0,
    //           -99.69
    //       ],
    //         label: {
    //           show: true,
    //         },
    //       },
    //       {
    //         name: "Manufacturing",
    //         type: "line",
    //         data: [2.7, 5.2, 3.6, 3.1, 1.7, -1.2, 6.0, 5.6, 4.6, 0.5, 8.5, 6.9],
    //         label: {
    //           show: true,
    //         },
    //       },
    //       {
    //         name: "Electricity",
    //         type: "line",
    //         data: [6.2, 2.4, 3.6, 1.7, -4.7, -1.2, 1.5, 4.7, 5.6, -6.9, -1.5, 6.3],
    //         label: {
    //           show: true,
    //         },
    //       },
    //       {
    //         name: "General",
    //         type: "line",
    //         smooth: true,
    //         areaStyle: {
    //           opacity: 0.3,
    //         },
    //         data: [3.7, 5.8, 1.6, 2.6, 2.5, 4.4, 5.2, 4.7, 5.6, 0.5, 5.8, 8.4],
    //         label: {
    //           show: true,
    //         },
    //       },
    //     ],
    //   };
      

    const containerClassName = className || (fullWidth ? "col-12 mb-4" : "col-xl-6 col-lg-6 mb-4");
    const cardStyle = {
        transition: 'all 0.3s ease',
        borderRadius: '12px',
        border: 'none',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        cursor: 'pointer',
        borderLeft: '4px solid #ff8c00'
      };
      const gradientText = {
        background: 'linear-gradient(135deg, #ff8c00 0%, #ff4500 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      };

      const emptyChartOption = {
        tooltip: { trigger: 'axis' },
        legend: { bottom: 0 },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value', name: 'Growth Rate (%)' },
        series: [],
      };

      const getChartData = async () => {
        setLoading(true);
        try {
          const response = await axios.post(`${API_URL}monthly-growth-rate-chart`, {
            survey_year: chartYear,
            month: ''
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          const chartOptions = response?.data?.data?.result?.options;
          setChartData(chartOptions && typeof chartOptions === 'object' ? chartOptions : emptyChartOption);
        } catch (error) {
          console.error('Failed to load monthly growth rate chart:', error);
          setChartData(emptyChartOption);
        } finally {
          setLoading(false);
        }
      };
      useEffect(() => {
        getChartData();
      }, [chartYear, iipMonth]);

    return (
        <div className={fullWidth ? "col-12 mb-4" : "col-xl-12 col-lg-12 mb-4"}>
        <div className="card h-100" style={cardStyle}>
          <div className="card-body">
            <div className="d-flex align-items-center mb-3 justify-content-between">
              <div className="d-flex align-items-center">
                <div className="fs-1 me-3" style={{ animation: 'pulse 2s infinite' }}>🏭</div>
                <div>
                  <h5 className="card-title mb-0" style={gradientText}>Monthly Growth Rate (In %) of Index of Industrial Production as per Sectoral ({chartYear})</h5>
                  <p className="text-muted mb-0 small">IIP Statistics</p>
                </div>
              </div>
              {/* Year and Month Dropdowns */}
              <div className="d-flex align-items-center ms-3" style={{ minWidth: 320, gap: 8 }}>
                <label htmlFor="iip-year-select" className="form-label fw-bold mb-0 me-2">Year:</label>
                <select
                  id="iip-year-select"
                  className="form-select form-select-sm d-inline-block me-2"
                  value={chartYear}
                  onChange={e => setChartYear(e.target.value)}
                  style={{ width: 80, height:35, display: 'inline-block' }}
                >
                  {chartYearOptions.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
                {/* <label htmlFor="iip-month-select" className="form-label fw-bold mb-0 me-2">Month:</label>
                <select
                  id="iip-month-select"
                  className="form-select form-select-sm d-inline-block"
                  value={iipMonth}
                  onChange={e => setIipMonth(e.target.value)}
                  style={{ width: 120, height:35, display: 'inline-block' }}
                >
                  {MONTHS.map(month => (
                    <option key={month.code} value={month.code}>{month.label}</option>
                  ))}
                </select> */}
              </div>
            </div>
  
            {loading  ? (
              <div className="text-center">Loading chart data...</div>
            ) : (
              <>
                 <ReactECharts
                // option={option}
                option={chartData}
                style={{ height: "600px" }}
                />
              </>
            )}
          </div>
        </div>
      </div>
    )
}

export default MonthlyGrowthRateChart;